import { publicUrl } from '@chegg-wt/core/utils/url'
import { Config } from '@chegg-wt/core/config'
import { CaretIcon, MenuIcon, LanguageIcon } from '@chegg-ui/horizon-icons'
import { useRoutesContext } from '../RoutesContext'
import AppLink from '../AppLink'

import {
  headerAccountItems,
  headerNavigationItems,
  HOME_PAGE_HEADER_TEST,
} from './constants'
import {
  CountryCode,
  HeaderWrapper,
  LeftNavItems,
  Logo,
  LogoContainer,
  LogoLink,
  MenuButton,
  NavItem,
  NavItems,
  RightNavItems,
  RightNavMobileItem,
} from './styled'

const HomePageHeader: React.FC = () => {
  const routes = useRoutesContext()
  const { logoAlt, logoWidth } = Config

  return (
    <HeaderWrapper data-test={HOME_PAGE_HEADER_TEST}>
      <LeftNavItems>
        <MenuButton>
          <MenuIcon size="medium" />
        </MenuButton>
        <LogoContainer>
          <AppLink route={routes.toCitationsHome()}>
            <LogoLink>
              <Logo
                alt={logoAlt}
                src={publicUrl('/static/logo.svg')}
                data-test="logo-button"
                onClick={() => null}
                width={logoWidth}
                height={30}
              />
            </LogoLink>
          </AppLink>
        </LogoContainer>
        <NavItems>
          {headerNavigationItems.map((item) => (
            <NavItem
              hideOnMobile={item.hideOnMobile}
              onClick={() => null}
              data-test={item.name}
            >
              {item.name}
            </NavItem>
          ))}
        </NavItems>
      </LeftNavItems>
      <RightNavItems>
        <RightNavMobileItem>
          <LanguageIcon size="medium" />
          <CountryCode>
            <div>EN</div>
            <CaretIcon pointing="down" size="small" />
          </CountryCode>
        </RightNavMobileItem>
        {headerAccountItems.map((item) => (
          <NavItem
            hideOnMobile={item.hideOnMobile}
            onClick={() => null}
            data-test={item.name}
          >
            {item.name}
          </NavItem>
        ))}
      </RightNavItems>
    </HeaderWrapper>
  )
}

export default HomePageHeader
